import KendoDataSourceBase from '../KendoDataSourceBase'
import PivotDataSourceProps from './PivotDataSourceProps'
import KendoPivotColumn from '../KendoPivotColumn'
import KendoPivotMeasure from '../KendoPivotMeasure'
import KendoPivotRow from '../KendoPivotRow'

import Schema from './Schema'
import Transport from './Transport'

export default {
    props: PivotDataSourceProps,
    render (h) {
        return h('div',this.$slots.default)
    },
    mixins: [
        KendoDataSourceBase,
        Schema,
        Transport
    ],
    mounted() {
        this._resolveChildren()

        this.kendoDataSource = new kendo.data.PivotDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.PivotDataSource(this.widgetOptions)
        },
        _resolveChildren() {
            this.resolveChildren('columns', KendoPivotColumn.name)
            this.resolveChildren('measures', KendoPivotMeasure.name)
            this.resolveChildren('rows', KendoPivotRow.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/KendoPivotDataSourceMixin.js